
export const CITY_COORDINATES = {
    // Major U.S. Cities
    'New York City': { lat: 40.7128, lng: -74.0060 },
    'Los Angeles': { lat: 34.0522, lng: -118.2437 },
    'Chicago': { lat: 41.8781, lng: -87.6298 },
    'Houston': { lat: 29.7604, lng: -95.3698 },
    'Phoenix': { lat: 33.4484, lng: -112.0740 },
    'Philadelphia': { lat: 39.9526, lng: -75.1652 },
    'San Antonio': { lat: 29.4241, lng: -98.4936 },
    'San Diego': { lat: 32.7157, lng: -117.1611 },
    'Dallas': { lat: 32.7767, lng: -96.7970 },
    'San Jose': { lat: 37.3382, lng: -121.8863 },
    
    // Additional Cities
    'Austin': { lat: 30.2672, lng: -97.7431 },
    'San Francisco': { lat: 37.7749, lng: -122.4194 },
    'Columbus': { lat: 39.9612, lng: -82.9988 },
    'Indianapolis': { lat: 39.7684, lng: -86.1581 },
    'Charlotte': { lat: 35.2271, lng: -80.8431 },
    'Seattle': { lat: 47.6062, lng: -122.3321 },
    'Denver': { lat: 39.7392, lng: -104.9903 },
    
    // More Cities
    'Boston': { lat: 42.3601, lng: -71.0589 },
    'El Paso': { lat: 31.7619, lng: -106.4850 },
    'Detroit': { lat: 42.3314, lng: -83.0458 },
    'Portland': { lat: 45.5155, lng: -122.6789 },
    'Oklahoma City': { lat: 35.4676, lng: -97.5164 },
    'Las Vegas': { lat: 36.1699, lng: -115.1398 },
    'Louisville': { lat: 38.2527, lng: -85.7585 },
    'Baltimore': { lat: 39.2904, lng: -76.6122 },
    'Milwaukee': { lat: 43.0389, lng: -87.9065 },
    'Tucson': { lat: 32.2226, lng: -110.9747 },
    'Cleveland': { lat: 41.4993, lng: -81.6944},
    'Kansas City': { lat: 39.0997, lng: -94.5786},
    'Long Beach': { lat: 33.7701, lng: -118.1937},
    'Memphis': { lat: 35.1495, lng: -90.0490},
    'Minneapolis': { lat: 44.9778, lng: -93.2650},
    'Oakland': { lat: 37.8044, lng: -122.2712},
  };